// extracted by mini-css-extract-plugin
export default {"bird_loader":"LoadingDove_bird_loader__zx+Tm","bird":"LoadingDove_bird__gMXnz","text":"LoadingDove_text__9uvVU"};